import React from 'react';

import { Iphone } from './styles';

export default ({ children, ...rest }) => {
  return (
    <Iphone {...rest}>
      <div>
        {children}
      </div>
    </Iphone>
  )
}
